// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--jps-sec-con-st{
    width: 100%;
    height: auto;
}

.scl--jscs-inp-con-st{
    width: 100%;
    height: 45px;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
    background-color: rgba(28, 27, 27, 1);
    border: 1px solid rgba(255, 255, 255, 0.02);
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
    cursor: pointer;
}

.scl--jscs-inp-con-st input{
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: none;
    outline: none;
    color: rgba(125, 129, 135, 1);
    font-size: 16px;
    font-family: var(--primary-font);
    transition: all 0.3s;
}

.scl--jscs-inp-con-st svg path{
    transition: all 0.3s;
}

.scl--jscs-inp-con-st:hover input, .scl--jscs-inp-con-st input:focus , .scl--jscs-inp-con-st:hover input::placeholder, .scl--jscs-inp-con-st:hover svg path, .scl--jscs-inp-con-st:focus-within svg path{
    color: white;
    cursor: text;
    stroke: white;
}

.scl--jscs-inp-con-st input::placeholder{
    color: rgba(125, 129, 135, 1);
    font-size: 16px;
    font-family: var(--primary-font);
    transition: all 0.3s;
}

.scl--jscs-inp-con-st::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 4px;
    background-color: rgba(132, 165, 120, 1);
    opacity: 0;
    transition: opacity 0.5s ease;
}

.scl--jscs-inp-con-st:focus-within::after {
    opacity: 1;
}

.scl--jscs-inp-con-st--has-value::after {
    opacity: 1;
}

@media (max-width: 500px) {
    .scl--jscs-inp-con-st{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-position/css/jp_Search.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,qCAAqC;IACrC,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,WAAW;IACX,wCAAwC;IACxC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;AACJ","sourcesContent":[".scl--jps-sec-con-st{\n    width: 100%;\n    height: auto;\n}\n\n.scl--jscs-inp-con-st{\n    width: 100%;\n    height: 45px;\n    padding-left: 20px;\n    padding-right: 20px;\n    box-sizing: border-box;\n    background-color: rgba(28, 27, 27, 1);\n    border: 1px solid rgba(255, 255, 255, 0.02);\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    position: relative;\n    cursor: pointer;\n}\n\n.scl--jscs-inp-con-st input{\n    width: 100%;\n    height: 100%;\n    background-color: transparent;\n    border: none;\n    outline: none;\n    color: rgba(125, 129, 135, 1);\n    font-size: 16px;\n    font-family: var(--primary-font);\n    transition: all 0.3s;\n}\n\n.scl--jscs-inp-con-st svg path{\n    transition: all 0.3s;\n}\n\n.scl--jscs-inp-con-st:hover input, .scl--jscs-inp-con-st input:focus , .scl--jscs-inp-con-st:hover input::placeholder, .scl--jscs-inp-con-st:hover svg path, .scl--jscs-inp-con-st:focus-within svg path{\n    color: white;\n    cursor: text;\n    stroke: white;\n}\n\n.scl--jscs-inp-con-st input::placeholder{\n    color: rgba(125, 129, 135, 1);\n    font-size: 16px;\n    font-family: var(--primary-font);\n    transition: all 0.3s;\n}\n\n.scl--jscs-inp-con-st::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 4px;\n    background-color: rgba(132, 165, 120, 1);\n    opacity: 0;\n    transition: opacity 0.5s ease;\n}\n\n.scl--jscs-inp-con-st:focus-within::after {\n    opacity: 1;\n}\n\n.scl--jscs-inp-con-st--has-value::after {\n    opacity: 1;\n}\n\n@media (max-width: 500px) {\n    .scl--jscs-inp-con-st{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
